<template>
  <div>
    <!-- 悬浮按钮 -->
    <!-- <div class="tjhy" @click="card_show=true" v-if="type==1 || type == 3" v-show="is_main">
            <a>推荐有礼</a>
        </div> -->
    <div class="tjhy" v-if="type==1 || type == 3" v-show="false">
      <router-link :to="jump_link + '?cid=' + cid">推荐有礼</router-link>
    </div>
    <div class="tjhy kfan" @click="assistant_show=true" v-if="type==2 || type == 3">
      <a>联系客服</a>
    </div>
    <!-- 卡片弹出层 -->
    <van-popup v-model="card_show" class="pop_card">
      <img :src="imgUrl" alt="请稍等图片正在加载">
      <h3>{{text_card}}</h3>
    </van-popup>
    <!-- 助理二维码弹出层 -->
    <van-popup v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <img src="@a/details_new.png" />
        <h3><span v-html="text_assistant" ></span><span class="on">{{insert_text}}</span></h3>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  isMain
} from '@/utils/tools';
import {
  getActivity
} from "@/api/course"
export default {
  data() {
      return {
        card_show: false,
        assistant_show: false,
        is_main: false,
        jump_link: ''
      }
    },
    props: {
      imgUrl: {
        type: String,
        default: ''
      },
      text_assistant: {
        type: String,
        default: ''
      },
      text_card: {
        type: String,
        default: ''
      },
      insert_text: {
        type: String,
        default: ''
      },
      type: {
        type: Number,
        default: null
      },
      cid: {
        type: Number,
        default: null
      }
    },
    methods: {
      pullData() {
        getActivity({
            cid: this.cid
          })
          .then((data) => {
            // if (data.jump) {
            //   this.jump_link = '/event_details';
            // } else {
              this.jump_link = '/make_money';
            // }
          })
      }
    },
    created() {
      this.pullData()
    },
}
</script>
<style lang="scss" scoped>
@import "~@s/remChange.scss";
// 悬浮按钮
.tjhy {
  position: fixed;
  z-index: 998;
  width: 150px;
  top: changeRem(2.72)+px;
  text-align: center;
  right: 50%;
  margin-right: -375px;
  height: changeRem(1.4)+px;
  background-color: #EB5032;
  border-radius: changeRem(.56)+px 0 0 changeRem(.56)+px;
  padding-left: changeRem(.12)+px;
  padding-top: changeRem(.1)+px;
  a {
    display: block;
    width: changeRem(2.84)+px;
    line-height: changeRem(1.12)+px;
    border: 2px solid #ffffff;
    border-right: 0;
    color: #FFFFFF;
    font-size: changeRem(.48)+px;
    border-radius: changeRem(.56)+px 0rem 0rem changeRem(.56)+px;
  }
}

.tjhy.kfan {
  top: changeRem(4.72)+px;
  background-color: #F57F17;
  div {
    width: changeRem(2.84)+px;
    line-height: changeRem(1.12)+px;
    border: 2px solid #ffffff;
    border-right: 0;
    color: #FFFFFF;
    font-size: changeRem(.48)+px;
    border-radius: changeRem(.56)+px 0rem 0rem changeRem(.56)+px;
  }
}

// 弹出卡片
.pop_card {
  background-color: transparent;
  text-align: center;
  img {
    width: changeRem(12)+px;
  }
  h3 {
    margin-top: changeRem(.8)+px;
    line-height: 1;
    color: #fff;
    font-size: changeRem(.52)+px;
    background-color: transparent;
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 105px 85px 84px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 20px;
    }
  }
}
</style>
